import { useState } from "react";
import api, { formatApiErrorDetail } from "@/lib/apiClient";
import { Button } from "@/components/ui/button";
import {
  Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription,
} from "@/components/ui/dialog";
import { Sparkles, Loader2 } from "lucide-react";
import { toast } from "sonner";

export function WeeklySummary({ studentId, studentName, label }) {
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [text, setText] = useState("");

  const generate = async () => {
    setOpen(true);
    setLoading(true);
    setText("");
    try {
      const { data } = await api.get(`/ai/weekly-summary/${studentId}`);
      setText(data.result);
    } catch (e) {
      toast.error(formatApiErrorDetail(e.response?.data?.detail));
      setOpen(false);
    }
    setLoading(false);
  };

  return (
    <>
      <Button
        variant="outline"
        size="sm"
        className="rounded-full"
        onClick={generate}
        data-testid={`weekly-summary-button-${studentId}`}
      >
        <Sparkles className="h-4 w-4 mr-1.5" /> {label || "AI Weekly Summary"}
      </Button>
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent className="max-h-[85vh] overflow-y-auto">
          <DialogHeader>
            <DialogTitle className="font-brand font-light text-2xl">{studentName} — Weekly Summary</DialogTitle>
            <DialogDescription>AI-generated from recent sessions. Please review before relying on it.</DialogDescription>
          </DialogHeader>
          {loading ? (
            <div className="py-12 flex flex-col items-center gap-3 text-muted-foreground text-sm">
              <Loader2 className="h-6 w-6 animate-spin" /> Generating summary…
            </div>
          ) : (
            <p className="text-sm whitespace-pre-wrap leading-relaxed" data-testid="weekly-summary-text">
              {text || "No summary available."}
            </p>
          )}
        </DialogContent>
      </Dialog>
    </>
  );
}
